import baseMessage from './baseMessage'

export const ES_CO = {
  message: {
    ...baseMessage,
    label: {
      dni: 'Cédula de Ciudadanía',
      userHint: 'Se puede buscar por Nombres, Apellidos, Cédula de Ciudadanía'
    },
    selfService: {
      fields: {
        state: 'Departamento',
        city: 'Municipio',
        department: 'Apartamento',
        cbu: 'Número de cuenta'
      }
    }
  }
}
